import { Fragment } from "react";

import { FaqItem as FaqItemData } from "../data/faq";
import { ChevronDownIcon } from "./icons/ChevronDownIcon";

interface Props {
  item: FaqItemData;
  isOpen: boolean;
  onToggle: () => void;
}

export const FaqItem = ({ item, isOpen, onToggle }: Props) => {
  return (
    <div className="flex flex-col gap-4 rounded-2xl">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`faq-${item.id}`}
        className="flex w-full items-center gap-6 text-left"
      >
        <span className="flex-1 text-[19px] leading-[1.6] text-primary [font-weight:600]">
          {item.question}
        </span>
        <span
          className={[
            "inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#FFD100] transition-transform",
            isOpen ? "rotate-180" : "",
          ].join(" ")}
        >
          <ChevronDownIcon size={16} color="#0D0D0D" />
        </span>
      </button>

      {isOpen && (
        <div
          id={`faq-${item.id}`}
          className="flex flex-col gap-4 text-[16px] leading-[1.6] text-primary"
        >
          {item.answer.map((paragraph, paragraphIdx) => (
            <p key={paragraphIdx}>
              {paragraph.map((segment, segmentIdx) =>
                typeof segment === "string" ? (
                  <Fragment key={segmentIdx}>{segment}</Fragment>
                ) : (
                  <strong key={segmentIdx} className="[font-weight:600]">
                    {segment.bold}
                  </strong>
                )
              )}
            </p>
          ))}
        </div>
      )}

      <div className="h-px w-full bg-[#EAEAEA]" />
    </div>
  );
};
